const SizesUtils = require('../../../viscomjs/utils/SizesUtils');

module.exports = () => {
    const arr = [
        ['forest', './img/animations/bg_forest.svg'],
        ['mountains', './img/animations/bg_mountains.svg'],
        ['river', './img/animations/bg_river.svg'],
        ['img4', './img/animations/forest_light_mono_v2.png']
    ];
    const w = SizesUtils.winWidth();

    if (w < 1330) {
        arr.push(['img0', './img/animations/forest_light_bg_v3.png']);
        arr.push(['img1', './img/animations/forest_light_trees_1_v3.png']);
        arr.push(['img2', './img/animations/forest_light_trees_2_v3.png']);
        arr.push(['img3', './img/animations/forest_light_v3.png']);
        return arr;
    }

    arr.push(['img0', './img/animations/forest_light_bg_v3_x2.png']);
    arr.push(['img1', './img/animations/forest_light_trees_1_v3_x2.png']);
    arr.push(['img2', './img/animations/forest_light_trees_2_v3_x2.png']);
    arr.push(['img3', './img/animations/forest_light_v3_x2.png']);
    return arr;
};
